import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpEvent,
  HttpEventType,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  constructor(private http: HttpClient) { }

  uploadFileToS3(
    signedUrl: string,
    file: File,
    onProgress: (progress: number) => void
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': file.type
    });

    const req = new HttpRequest('PUT', signedUrl, file, {
      reportProgress: true,
      headers: headers,
      responseType: 'text',
    });
    return this.http.request(req).pipe(
      map((event) => {
        return this.handleHttpEvent(event, onProgress);
      }),
      catchError((error) => {
        console.error('Upload failed:', error);
        throw new Error(`Upload failed: ${error.message}`);
      })
    );
  }

  private handleHttpEvent(
    event: HttpEvent<any>,
    onProgress: (progress: number) => void
  ): any {
    if (event.type === HttpEventType.UploadProgress && event.total) {
      const percentDone = Math.round((100 * event.loaded) / event.total);
      onProgress(percentDone);
    } else if (event instanceof HttpResponse) {
      return 'Upload completed';
    }
  }
}
